module.exports = __webpack_public_path__ + "static/media/166-morocco.a69748b1.svg";